import React, { useEffect, useRef } from 'react';

interface IProps {
  src: string;
  className?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
}

const VideoPlayer: React.FC<IProps> = ({
  src,
  className = '',
  autoPlay = false,
  loop = false,
  muted = false,
  controls = true
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const isYouTube = /youtube\.com|youtu\.be/.test(src);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    // Disable context menu
    const prevent = (e: Event) => {
      e.preventDefault();
      return false;
    };

    video.disablePictureInPicture = true;
    video.setAttribute('controlsList', 'nodownload noremoteplayback noplaybackrate');

    video.addEventListener('contextmenu', prevent);
    video.addEventListener('dragstart', prevent);

    // eslint-disable-next-line consistent-return
    return () => {
      video.removeEventListener('contextmenu', prevent);
      video.removeEventListener('dragstart', prevent);
    };
  }, []);

  if (!src) return null;

  if (isYouTube) {
    return (
      <div className={`h-full w-full ${className}`}>
        <iframe
          src={src}
          className="h-full w-full rounded-xl"
          title="YouTube Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className={`h-full w-full ${className}`}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        ref={videoRef}
        src={src}
        className="h-full w-full select-none rounded-xl"
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        controls={controls}
        playsInline
        preload="metadata"
        onContextMenu={e => e.preventDefault()}
      />
    </div>
  );
};

export default VideoPlayer;
